import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { Agent } from "src/app/shared/models/agent.model";
import { Company } from "src/app/shared/models/company";
import { Regional } from "src/app/shared/models/regional";
import {
  ServiceLocal,
  ServiceRequest,
  ServiceRequestAttachmentFile,
} from "src/app/shared/models/service-request.model";
import { User } from "src/app/shared/models/user.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { ServiceRequestService } from "../../service-request.service";
moment.locale("pt-br");

@Component({
  selector: "app-service-request-details",
  templateUrl: "./service-request-details.component.html",
  styleUrls: ["./service-request-details.component.scss"],
})
export class ServiceRequestDetailsComponent implements OnInit, OnDestroy {
  goback = "../list";
  serviceRequestForm: FormGroup;
  queryParams: any = {};
  now = Date.now();
  subscription = new Subscription();
  userLogged: User = {};
  maxAttachment = globalConst.attachment.max;

  loadedServiceRequest: ServiceRequest;
  attachmentsFile: ServiceRequestAttachmentFile[] = [];

  associateAgentForm: FormGroup;
  agents: Agent[] = [];

  disableRegional = false;

  companyOptions: Company[] = [];
  filteredCompanyOptions: Company[] = this.companyOptions;
  regionalOptions: Regional[] = [];
  filteredRegionalOptions: Regional[] = this.regionalOptions;
  serviceLocalOptions: ServiceLocal[] = [];
  filteredServiceLocalOptions: ServiceLocal[] = this.serviceLocalOptions;

  allOptions: any = {
    id: "T",
    description: "TODAS",
  };

  maxCaracteres = 2000;
  globalConst = globalConst;

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private serviceRequestService: ServiceRequestService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.userLogged = this.authService.getUserLogged();
  }

  async ngOnInit() {
    this.spinner.show();
    try {
      this.route.queryParams.subscribe(
        (params: any) => (this.queryParams = params)
      );

      this.serviceRequestForm = this.fb.group({
        observation: this.fb.control("", Validators.required),
        company: this.fb.control("", Validators.required),
        regional: this.fb.control("", Validators.required),
        serviceLocal: this.fb.control("", Validators.required),
        priority: this.fb.control("", Validators.required),
        attendance_type: this.fb.control("", Validators.required),
        line: this.fb.control("", Validators.required),
        whatsapp_ddi: this.fb.control("", [
          Validators.required,
          Validators.maxLength(2),
        ]),
        whatsapp_ddd: this.fb.control("", [
          Validators.required,
          Validators.maxLength(3),
        ]),
        whatsapp_number: this.fb.control("", [
          Validators.required,
          Validators.maxLength(11),
        ]),
        email_cc: this.fb.control("", [Validators.maxLength(300)]),
      });

      if (this.queryParams.id) {
        this.loadServiceRequest(this.queryParams.id);
        this.associateAgentForm = this.fb.group({
          agentId: this.fb.control(null, Validators.required),
        });
        await this.loadAgents();
      }

      if (!this.queryParams.id) {
        await this.loadCompanyOptions();
        await this.loadRegionalOptions();
        await this.loadServiceLocal();

        this.listenChangeCompany();
        this.listenChangeRegional();
        this.listenChangeServiceLocal();
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private listenChangeCompany() {
    const control = this.serviceRequestForm.controls.company;
    control.valueChanges.subscribe(async () => {
      if (
        !control.errors &&
        control.value.alternativeIdentifier !== undefined
      ) {
        try {
          this.spinner.show();
          this.regionalOptions = [];
          this.serviceRequestForm.controls.regional.setValue(null);
          await this.loadRegionalOptions();
          this.regionalOptions = this.regionalOptions.filter(
            (obj) =>
              obj.companyAlternativeIdentifier ===
              control.value.alternativeIdentifier
          );
          this.filteredRegionalOptions = this.regionalOptions;
          if (!this.regionalOptions.length) {
            Alert.warning(Alert.getMessage().errors.regional.emptySearch);
          }

          this.serviceLocalOptions = [];
          this.filteredServiceLocalOptions = this.serviceLocalOptions;
          await this.loadServiceLocal();
          this.loadAllServiceLocalsByCompany();

          // this.disableRegional = (this.userLogged.type !== globalConst.defaults.user.client);
          this.serviceRequestForm.controls.regional.setValue({});
          this.spinner.hide();
        } catch (error) {
          this.spinner.hide();
          Helper.handleError(error);
        }
      }
    });
  }

  private listenChangeRegional() {
    const control = this.serviceRequestForm.controls.regional;
    control.valueChanges.subscribe(async () => {
      if (!control.errors && control.value.id !== undefined) {
        try {
          this.spinner.show();
          await this.loadServiceLocal();
          if (control.value.id === "T") {
            this.loadAllServiceLocalsByCompany();
          } else {
            this.serviceLocalOptions = this.serviceLocalOptions.filter(
              (obj) => obj.regionalId === control.value.id
            );
            this.filteredServiceLocalOptions = this.serviceLocalOptions;
            if (!this.serviceLocalOptions.length) {
              Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
            }
          }
          this.spinner.hide();
        } catch (error) {
          this.spinner.hide();
          Helper.handleError(error);
        }
      }
    });
  }

  private listenChangeServiceLocal() {
    const control = this.serviceRequestForm.controls.serviceLocal;
    control.valueChanges.subscribe(async () => {
      if (!control.errors) {
        this.serviceRequestForm.controls.regional.setValue(
          this.regionalOptions.find(
            (obj) => obj.id === control.value.regionalId
          )
        );
      }
    });
  }

  private loadAllServiceLocalsByCompany() {
    const auxServiceLocal = [];
    this.serviceRequestForm.controls.serviceLocal.setValue(null);
    this.regionalOptions.map((regional) => {
      // tslint:disable-next-line: max-line-length
      this.serviceLocalOptions
        .filter((obj) => obj.regionalId === regional.id)
        .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
    });
    this.serviceLocalOptions = auxServiceLocal;
    this.filteredServiceLocalOptions = this.serviceLocalOptions;
    if (!this.serviceLocalOptions.length) {
      Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
    }
  }

  async loadCompanyOptions() {
    try {
      const data: any = await this.serviceRequestService.getCompanies();
      this.companyOptions =
        this.userLogged.type === globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.userLogged.companiesAssociate;
      this.filteredCompanyOptions = this.companyOptions;
      if (!this.companyOptions.length) {
        Alert.warning(Alert.getMessage().errors.company.emptySearch);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async loadRegionalOptions() {
    try {
      const data: any = await this.serviceRequestService.getRegionals();
      this.regionalOptions =
        this.userLogged.type === globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.userLogged.regionalsAssociate;
      this.filteredRegionalOptions = this.regionalOptions;
    } catch (error) {
      console.error(error);
    }
  }

  async loadServiceLocal() {
    try {
      const data: any = await this.serviceRequestService.getServiceLocals();
      this.serviceLocalOptions =
        this.userLogged.type === globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.userLogged.serviceLocalsAssociate;
      this.filteredServiceLocalOptions = this.serviceLocalOptions;
    } catch (error) {
      console.error(error);
    }
  }

  async loadAgents() {
    try {
      const data: any = await this.serviceRequestService.getAgents();
      this.agents =
        data.status === undefined ? Agent.orderAgentByName(data) : [];
    } catch (error) {
      console.error(error);
    }
  }

  async loadServiceRequest(serviceRequestId) {
    try {
      const data: any = await this.serviceRequestService.getSchedule(
        serviceRequestId
      );
      this.loadedServiceRequest = data.status === undefined ? data : [];
    } catch (error) {
      console.error(error);
    }
  }

  async onSubmit() {
    if (!this.serviceRequestForm.invalid) {
      this.spinner.show();
      const date = new Date();

      const serviceRequest: ServiceRequest = {
        date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        hour: moment().format("LT"),
        observation: this.serviceRequestForm.value.observation,
        serviceLocalId: this.serviceRequestForm.value.serviceLocal.id,
        serviceLocalDescription:
          this.serviceRequestForm.value.serviceLocal.description,
        serviceLocalEmail: this.serviceRequestForm.value.serviceLocal.email,
        companyDescription: this.serviceRequestForm.value.company.description,
        regionalDescription: this.serviceRequestForm.value.regional.description,
        priority: this.serviceRequestForm.value.priority,
        attendance_type: this.serviceRequestForm.value.attendance_type,
        line: this.serviceRequestForm.value.line,
        whatsapp_ddi: this.serviceRequestForm.value.whatsapp_ddi,
        whatsapp_ddd: this.serviceRequestForm.value.whatsapp_ddd,
        whatsapp_number: this.serviceRequestForm.value.whatsapp_number,
        email_cc: this.serviceRequestForm.value.email_cc,
      };

      const verifyOpening = await this.serviceRequestService.verifyOpening(
        serviceRequest.serviceLocalId
      );

      if (verifyOpening) {
        this.spinner.hide();
        Alert.question(Alert.getMessage().question.openSchedule).then(
          async (response) => {
            if (response.value) {
              await this.createSchedule({ ...serviceRequest });
            }
          }
        );
      } else {
        await this.createSchedule({ ...serviceRequest });
      }
    }
  }

  async createSchedule(serviceRequest: ServiceRequest) {
    this.spinner.show();

    this.serviceRequestService
      .createSchedule({
        ...serviceRequest,
        userId: this.userLogged.id,
        userEmail: this.userLogged.email,
        requester: this.userLogged.name,
        requesterEmail: this.userLogged.email,
        serviceLocalEmail: serviceRequest.serviceLocalEmail || "",
      })
      .subscribe(
        async (resource) => {
          /* const body = {
            requester: this.userLogged.name,
            requesterEmail: this.userLogged.email,
            scheduleId: resource.resourceId,
            // serviceLocalEmail: serviceRequest.serviceLocalEmail,
            ...serviceRequest,
          }; */
          this.spinner.hide();
          Alert.success("Solicitação aberta com sucesso").then(() => {
            this.router.navigate(["../serviceRequest/list"]);
          });

          /*  this.spinner.show("mailSpinner");
          await this.serviceRequestService.insertSchedule(body);
          await this.serviceRequestService.associateSchedule(
            resource.resourceId
          );
          this.spinner.hide("mailSpinner");
          Alert.success(Alert.getMessage().success.sendEmail).then(() => {
            this.router.navigate(["../serviceRequest/list"]);
          }); */
        },
        (error) => {
          this.spinner.hide();
          console.error(error);
        }
      );
  }

  registerDocument(file: any) {
    if (file.target.files.length > this.maxAttachment) {
      Alert.error(Alert.getMessage().errors.fileLimit);
    } else {
      const totalAttachments = file.target.files.length;
      for (file of file.target.files) {
        const reader = new FileReader();
        const extension = file.name.split(".").reverse()[0];
        const fileName = file.name;
        const allowExtensions = ["jpeg", "jpg", "png"];
        const checkExtension = allowExtensions.find(
          (extensions) => extensions === extension
        );

        if (checkExtension === undefined) {
          // tslint:disable-next-line: max-line-length
          Alert.error(
            `Ocorreu um erro ao anexar o arquivo: ${file.name} a extensão .${extension} não é permitida utilize as extensões: JPEG, JPG, PNG`
          );
          continue;
        }

        const totalFiles = this.attachmentsFile.length + totalAttachments;

        if (totalFiles <= this.maxAttachment) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.attachmentsFile.push({
              name: fileName,
              extension,
              blob: reader.result,
            });
          };
        } else {
          Alert.error(Alert.getMessage().errors.fileLimit);
        }
      }
    }
  }

  deleteDocument(name: string) {
    Alert.question(Alert.getMessage().question.delete).then((response) => {
      if (response.value) {
        const findPos = this.attachmentsFile.indexOf(
          this.attachmentsFile.find((attachment) => attachment.name === name)
        );
        this.attachmentsFile.splice(findPos, 1);
      }
    });
  }

  associateAgent() {
    if (this.associateAgentForm.valid) {
      this.spinner.show();
      this.subscription.add(
        this.serviceRequestService
          .updateServiceRequestAgent(
            this.associateAgentForm.get("agentId").value,
            this.loadedServiceRequest.id
          )
          .subscribe(
            () => {
              this.spinner.hide();
              Alert.success(Alert.getMessage().success.save);
            },
            (error) => {
              if (error.status === 200 || error.status === 201) {
                this.spinner.hide();
                Alert.success(Alert.getMessage().success.save).then(
                  async () => {
                    this.spinner.show();
                    await this.serviceRequestService.updateSchedule(
                      this.loadedServiceRequest.id
                    );
                    await this.loadServiceRequest(this.loadedServiceRequest.id);
                    this.spinner.hide();

                    this.spinner.show("mailSpinner");

                    const emailSended =
                      await this.serviceRequestService.sendAgentEmail(
                        this.associateAgentForm.get("agentId").value,
                        this.loadedServiceRequest.id
                      );

                    if (!_.isEmpty(emailSended.error)) {
                      this.spinner.hide("mailSpinner");
                      Alert.warning(Alert.getMessage().errors.sendEmail).then(
                        () => {
                          this.router.navigate(["../serviceRequest/list"]);
                        }
                      );
                    } else {
                      this.spinner.hide("mailSpinner");
                      Alert.success(Alert.getMessage().success.sendEmail).then(
                        () => {
                          this.router.navigate(["../serviceRequest/list"]);
                        }
                      );
                    }
                  }
                );
              } else {
                this.spinner.hide();
                Helper.handleError(error);
              }
            }
          )
      );
    }
  }

  displayDescription(object?: any): string {
    return !_.isEmpty(object) ? `${object.description}` : "";
  }

  filterCompanyOptions(value?: string) {
    value = value.trim();
    this.filteredCompanyOptions = value
      ? this._filterCompany(value)
      : this.companyOptions.slice();
  }

  private _filterCompany(name: string): Company[] {
    const filterValue = name.toLowerCase();
    const searchName = this.companyOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );

    if (searchName.length) {
      return searchName;
    }

    return this.companyOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }

  filterRegionalOptions(value?: string) {
    value = value.trim();
    this.filteredRegionalOptions = value
      ? this._filterRegional(value)
      : this.regionalOptions.slice();
  }

  private _filterRegional(name: string): Regional[] {
    const filterValue = name.toLowerCase();
    const searchName = this.regionalOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );

    if (searchName.length) {
      return searchName;
    }

    return this.regionalOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }

  filterServiceLocalOptions(value?: string) {
    value = value.trim();
    this.filteredServiceLocalOptions = value
      ? this._filterServiceLocal(value)
      : this.serviceLocalOptions.slice();
  }

  private _filterServiceLocal(name: string): ServiceLocal[] {
    const filterValue = name.toLowerCase();
    const searchName = this.serviceLocalOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );

    if (searchName.length) {
      return searchName;
    }

    return this.serviceLocalOptions.filter((option) =>
      option.description.toLowerCase().includes(filterValue)
    );
  }
}
